import { fetchData, API_TYPE, IResponse } from '@umu/umu-fetch';
import { safeJSONParse } from '../../../../../@utils/jsonParse';
import EventEmitter from 'events';
import { RENDER_TYPE, RENDER_HIT_TYPE, IPdfImages } from '../base';

const Api = {
    /**
     * 使用Apollo的配置，获取对应pdf url指定的类型
     */
    GET_RENDER_TYPE: {
        url: `/napi/config/center`,
        type: API_TYPE.GET,
    },
};

/**
 * @see https://app.asana.com/0/357313196454880/1204063174133986/f
 * @param key apollo key
 * @returns
 */
class ConfigRenderHelper extends EventEmitter {
    /**
     * 企业id的key
     */
    static ENTERPRISE_ID = 'enterpriseId';
    /**
     * 小节id
     */
    static ELEMENT_ID = 'elementId';

    /**
     * pdf url
     */
    static PDF_URL = 'pdfUrl';
    /**
     * 当前所有配置
     */
    static RENDER_TYPE_CONFIG: { [key: string]: 'svg' } | null = null;
    /**
     * 最大等待时间
     */
    static EVENT_CONFIG_LOADED = 'event_pdf_render_type_config_loaded';

    isLoaded: boolean = false;

    /**
     * 渲染类型命中类型
     */
    hitType: RENDER_HIT_TYPE = RENDER_HIT_TYPE.NONE;

    public getRenderType = (pdfUrl: string, elementId?: string, enterpriseId?: string, pdfImages?: IPdfImages) => {
        if (this.isEnableImageRender(pdfImages)) {
            return RENDER_TYPE.IMAGE;
        } else if (this.isEnableSvgRender(pdfUrl, elementId, enterpriseId)) {
            return RENDER_TYPE.SVG;
        }
        return RENDER_TYPE.CANVAS;
    };

    public async loadConfig() {
        const key = 'session_document_pdf_render_type';
        const params = {
            key,
        };
        try {
            const res: IResponse<string> = await fetchData(Api.GET_RENDER_TYPE, params);
            ConfigRenderHelper.RENDER_TYPE_CONFIG = safeJSONParse(res.data || '{}', {});
            this.isLoaded = true;
        } catch (error) {
            console.error('load pdf_render_type error:', error);
            this.isLoaded = false;
            throw new Error('load pdf_render_type error');
        } finally {
            this.emit(ConfigRenderHelper.EVENT_CONFIG_LOADED, {
                isLoaded: this.isLoaded,
            });
        }
    }

    /**
     * 是否加载完成
     * @param pdfUrl
     */
    onConfigLoaded(cb: (isLoaded: boolean) => void) {
        this.on(ConfigRenderHelper.EVENT_CONFIG_LOADED, (params: { isLoaded: boolean }) => {
            cb(params.isLoaded);
        });
    }

    isEnableImageRender(pdfImages?: IPdfImages) {
        return !!pdfImages;
    }

    /**
     * 是否允许pdf使用svg
     * @param pdfUrl
     * @returns
     */
    isEnableSvgRender(resourceUrl?: string, elememtId?: string, enterpriseId?: string) {
        if (!ConfigRenderHelper.RENDER_TYPE_CONFIG) {
            return false;
        }

        // 小节id命中白名单
        if (this.isEnableSvgRenderInElement(elememtId)) {
            this.hitType = RENDER_HIT_TYPE.ELEMENT_ID;
            return true;
        }

        // pdf url命中
        if (this.isEnableSvgRenderByPdfUrl(resourceUrl)) {
            this.hitType = RENDER_HIT_TYPE.PDF_URL;
            return true;
        }

        // 企业id命中白名单
        if (this.isEnableSvgRenderInEnterprise(enterpriseId)) {
            this.hitType = RENDER_HIT_TYPE.ENTERPRISE_ID;
            return true;
        }

        return false;
    }

    private isEnableSvgRenderInEnterprise(enterpriseId?: string) {
        if (!enterpriseId || !ConfigRenderHelper.RENDER_TYPE_CONFIG) {
            return false;
        }
        const list = ConfigRenderHelper.RENDER_TYPE_CONFIG[ConfigRenderHelper.ENTERPRISE_ID] || '';
        return this.isIdInList(enterpriseId, list);
    }

    private isEnableSvgRenderInElement(elememtId?: string) {
        if (!elememtId || !ConfigRenderHelper.RENDER_TYPE_CONFIG) {
            return false;
        }
        const list = ConfigRenderHelper.RENDER_TYPE_CONFIG[ConfigRenderHelper.ELEMENT_ID] || '';
        return this.isIdInList(elememtId, list);
    }

    private isEnableSvgRenderByPdfUrl(resourceUrl?: string) {
        if (!resourceUrl || !ConfigRenderHelper.RENDER_TYPE_CONFIG) {
            return false;
        }
        const list = ConfigRenderHelper.RENDER_TYPE_CONFIG[ConfigRenderHelper.PDF_URL] || '';
        return this.isIdInList(resourceUrl, list);
    }

    /**
     *
     * @param id 需要查找的id
     * @param ids "1,2,3,4,5"
     * @returns
     */
    isIdInList(id: string, ids: string = '') {
        const list = ids.split(',');
        return (
            list.filter((element) => {
                return element.trim() === (id + '').trim();
            }).length > 0
        );
    }
}

const configRenderHelper = new ConfigRenderHelper();

export { configRenderHelper };
